const removeElement = (el) => {
    if (typeof el.remove !== 'undefined') {
        el.remove();
    } else {
        el.parentNode.removeChild(el);
    }
};
// eslint-disable-next-line
export { removeElement };
